import React from 'react';
import HomePage from '../homePage/HomePage';

const PartOnePage = () => {
    return (
        <HomePage />
    );
};

export default PartOnePage;